import { Dialog, GenericSuspense, Menu, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { useCallback, useEffect} from "react";
import { Outlet, useNavigate } from "react-router-dom";

const ProjectEventEditContainer = () => {

    const [TITLE] = useTranslations(i18n);
    const navigate = useNavigate()
    const urlParamsToString = useUrlParamsValueToString()

    const handleClose = useCallback(() => {
        navigate(`..?${urlParamsToString}`)
    }, [urlParamsToString])

    return (
        <Dialog open title={TITLE} onClose={handleClose} className="">
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </Dialog>
    );
};

export default ProjectEventEditContainer;

const i18n = ["std_edit"];
